// Neue Projekte hier einfach als weiteres Objekt ergänzen.
const U = (id, extra = "") =>
    `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85${extra}`;

export const projects = [
    {
        slug: "milkx",
        name: "MILKX",
        category: "Branding / Packaging & Kampagne",
        filter: "Branding",
        year: "2026",
        client: "MilkX Protein",
        description:
            "Eine Proteinmarke mit Attitüde. Für MILKX entstand das komplette Erscheinungsbild — vom Bullen-Maskottchen und Logosystem über das Packaging dreier Sorten bis zur Plakatkampagne »Unleash your power«. Kraftvoll, laut und sofort wiedererkennbar.",
        cover: "/media/projects/milkx-logo-cut.webp",
        images: [
            { src: "/media/projects/milkx-logo.jpg", caption: "Logo & Maskottchen" },
            { src: "/media/projects/milkx-packaging.jpg", caption: "Packaging-Design — Vanille, Lime Himbeere, Peanutbutter" },
            { src: "/media/projects/milkx-video.mp4", webm: "/media/projects/milkx-video.webm", poster: "/media/projects/milkx-video-poster.jpg", caption: "Markenfilm — Unleash your power", video: true, clickToPlay: true },
            { src: "/media/projects/milkx-poster-himbeere.jpg", caption: "Plakatkampagne — Lime Himbeere" },
            { src: "/media/projects/milkx-poster-peanutbutter.jpg", caption: "Plakatkampagne — Peanutbutter" },
            { src: "/media/projects/milkx-poster-vanille.jpg", caption: "Plakatkampagne — Vanille" },
        ],
    },
    {
        slug: "court-and-street",
        name: "COURT & STREET",
        category: "Editorial Design / Magazin",
        filter: "Editorial",
        year: "2025",
        client: "Court & Street Magazine",
        description:
            "Ein Magazin zwischen Spielfeld und Asphalt. Für COURT & STREET entstand ein Editorial-System, das Sportkultur mit urbaner Typografie verbindet — mutige Raster, rohe Texturen und eine Bildsprache, die Bewegung sichtbar macht.",
        cover: "/media/projects/court-street-shoe-cut.webp",
        images: [
            { src: "/media/projects/court-street-logo.jpg", caption: "Logo & Markenzeichen" },
            { src: "/media/projects/court-street-icon.jpg", caption: "Cover & Editorial-Design — ICON Ausgabe" },
            { src: "/media/projects/court-street-magazin.jpg", caption: "Magazin-Spreads & Layoutsystem" },
        ],
    },
    {
        slug: "olympia",
        name: "OLYMPIA",
        category: "Branding / Visual Identity",
        filter: "Branding",
        year: "2026",
        client: "Rhein-Ruhr 2036",
        description:
            "Ein Zeichen für mehr als Sport. Für die Olympia-Vision Rhein-Ruhr 2036 entstand eine visuelle Identität, die Tradition und Moderne verbindet — vom geprägten Greif-Logo über die typografische Plakatserie »Ein Ziel. Viele Stimmen.« bis zum Fackel-Keyvisual.",
        cover: "/media/projects/olympia-griffin-cut.webp",
        images: [
            { src: "/media/projects/olympia-logo.jpg", caption: "Logo — Prägung & Detail" },
            { src: "/media/projects/olympia-stadion.jpg", caption: "Plakatserie — Vision in Bewegung" },
            { src: "/media/projects/olympia-typo.jpg", caption: "Plakatserie — Ein Ziel. Ein Fackellauf." },
            { src: "/media/projects/olympia-kajak.jpg", caption: "Plakatserie — Kanu-Linienwelt" },
            { src: "/media/projects/olympia-fackel.jpg", caption: "Key Visual — Die Fackel" },
            { src: "/media/projects/olympia-detail.jpg", caption: "Detail — Tradition trifft Moderne" },
            { src: "/media/projects/olympia-stimmen.jpg", caption: "Detail — Eine starke Gemeinschaft" },
        ],
    },
    {
        slug: "moonwalk",
        name: "MOONWALK",
        category: "Creative Design / Kampagne",
        filter: "Creative Design",
        year: "2026",
        client: "Moonwalk",
        description:
            "Same Planet. Higher Mindset. Für MOONWALK entstand eine komplette visuelle Welt: Plakatkampagne mit chromglänzenden Schachfiguren vor Mondlandschaft, Geschäftsausstattung von Visitenkarte bis Briefpapier und eine Capsule Collection aus Merch — Schwerelosigkeit, zum Anfassen.",
        cover: "/media/projects/moonwalk-pegasus-cut.webp",
        images: [
            { src: "/media/projects/moonwalk-logo.jpg", caption: "Logo — Prägung & Detail" },
            { src: "/media/projects/moonwalk-logo-animation.mp4", webm: "/media/projects/moonwalk-logo-animation.webm", poster: "/media/projects/moonwalk-animation-poster.jpg", caption: "Logo-Animation — MOONWALK in Motion", video: true, clickToPlay: true },
            { src: "/media/projects/moonwalk-poster-knight.jpg", caption: "Plakatkampagne — Plan the move." },
            { src: "/media/projects/moonwalk-poster-moon.jpg", caption: "Plakatkampagne — Claim the Moon." },
            { src: "/media/projects/moonwalk-poster-launch.jpg", caption: "Plakatkampagne — Excuse the Launch." },
            { src: "/media/projects/moonwalk-office.jpg", caption: "Office Collection — Briefpapier & Visitenkarten" },
            { src: "/media/projects/moonwalk-capsule.jpg", caption: "Capsule Collection — Merch & Accessoires" },
        ],
    },
    {
        slug: "kwa",
        name: "KWA",
        category: "Branding / Social Design",
        filter: "Branding",
        year: "2024",
        client: "KulturWerkstatt-Akademie e. V.",
        description:
            "Eine Marke, gebaut für den Feed. KWA erhielt eine flexible visuelle Identität mit modularen Templates, klarer Typografie und einer Farbwelt, die im Scroll sofort wiedererkennbar ist.",
        cover: "/media/projects/kwa-globe-cut.webp",
        images: [
            { src: "/media/projects/kwa-logo.webp", caption: "Logo — KulturWerkstatt-Akademie e. V." },
            { src: U("photo-1744686909434-fd158fca1c35", "&w=1800"), caption: "Social-Media-System" },
            { src: U("photo-1548248823-ce16a73b6d49", "&w=1800"), caption: "Template-Bibliothek" },
        ],
    },
    {
        slug: "ehrenmann",
        name: "EHRENMANN",
        category: "Branding / Print & Social Design",
        filter: "Branding",
        year: "2025",
        client: "Fahrschule Ehrenmann",
        description:
            "Hier fängt das Fahren an. Für die Fahrschule EHRENMANN entstand eine markante Identität in Schwarz und Orange — vom runden Badge-Logo mit Condensed-Typografie über mehrseitige Info-Flyer bis zur Social-Media-Reihe »Unsere Vorteile« mit eigens gestaltetem Icon-System.",
        cover: "/media/projects/ehrenmann-ring-cut.webp",
        images: [
            { src: "/media/projects/ehrenmann-logo.jpg", caption: "Logo — Badge & Wortmarke" },
            { src: "/media/projects/ehrenmann-flyer.jpg", caption: "Print — Flyer & Broschüren" },
            { src: "/media/projects/ehrenmann-vorteile.jpg", caption: "Social Media — Icon-System & Infografik" },
        ],
    },
    {
        slug: "photography",
        name: "PHOTOGRAPHY",
        category: "Content Creation / Fotografie",
        filter: "Content Creation",
        year: "2026",
        client: "BVISION Designer Studio",
        description:
            "Momente, die bleiben. PHOTOGRAPHY steht für den analogen Blick im digitalen Studio — Editorial-Shootings, Street und Porträt, kuratiert wie ein Filmarchiv: Korn, Polaroid-Rahmen und das Auge für den richtigen Moment.",
        cover: "/media/projects/photography-cover.jpg",
        images: [
            { src: "/media/projects/photography-cover.jpg", caption: "Key Visual — Photography" },
        ],
    },
    {
        slug: "videography",
        name: "VIDEOGRAPHY",
        category: "Content Creation / Videografie",
        filter: "Content Creation",
        year: "2026",
        client: "BVISION Designer Studio",
        description:
            "More than videos. VIDEOGRAPHY bündelt Bewegtbild aus dem Studio — von der cineastischen Sequenz bis zum Social-Clip, gedreht, geschnitten und gegraded mit dem Anspruch eines Kinolooks. 4K, Gimbal, Drohne, Story.",
        cover: "/media/projects/videography-cover.jpg",
        images: [
            { src: "/media/projects/videography-cover.jpg", caption: "Key Visual — Videography" },
        ],
    },
    {
        slug: "ai-videos",
        name: "AI VIDEOS",
        category: "AI Content / Creative Design",
        filter: "Creative Design",
        year: "2026",
        client: "BVISION Designer Studio",
        description:
            "KI-generierte Bildwelten mit cineastischem Anspruch. AI VIDEOS zeigt, wie weit generatives Filmemachen heute trägt — von der Action-Szene im Regen über das Dojo-Duell bis zum Drohnenflug an der Riviera. Konzeption, Prompting und Feinschliff aus dem Studio.",
        cover: "/media/projects/ai-videos-cover.jpg",
        images: [
            { src: "/media/projects/ai-videos-cover.jpg", caption: "Key Visual — AI Videos" },
            { src: "/media/projects/ai-video-1.mp4", webm: "/media/projects/ai-video-1.webm", poster: "/media/projects/ai-video-1-poster.jpg", caption: "AI-Video — Cinematic Action Scene", video: true, clickToPlay: true },
            { src: "/media/projects/ai-video-2.mp4", webm: "/media/projects/ai-video-2.webm", poster: "/media/projects/ai-video-2-poster.jpg", caption: "AI-Video — Cinematic Aerial, Côte d'Azur", video: true, clickToPlay: true },
            { src: "/media/projects/ai-video-3.mp4", webm: "/media/projects/ai-video-3.webm", poster: "/media/projects/ai-video-3-poster.jpg", caption: "AI-Video — Dojo Showdown", video: true, clickToPlay: true },
            { src: "/media/projects/ai-video-4.mp4", webm: "/media/projects/ai-video-4.webm", poster: "/media/projects/ai-video-4-poster.jpg", caption: "AI-Video — Der Kampf beginnt", video: true, clickToPlay: true },
        ],
    },
];

export const getProject = (slug) => projects.find((p) => p.slug === slug);
export const getNextProject = (slug) => {
    const i = projects.findIndex((p) => p.slug === slug);
    return projects[(i + 1) % projects.length];
};
